import DrawerSimple from "ds/components/DrawerNew/Simple";
import { ApiKeyType } from "types/generated";
import { createDrawer, createDrawerTrigger } from "ds/components/DrawerNew/utils";
import DrawerHeader from "ds/components/Drawer/Header";
import DrawerHeaderTitle from "ds/components/DrawerNew/HeaderTitle";
import DrawerCloseIcon from "ds/components/DrawerNew/CloseIcon";
import DrawerBody from "ds/components/Drawer/Body";
import FormFieldViewText from "components/FormFields/ViewText";
import FormField from "ds/components/Form/Field";
import Typography from "ds/components/Typography";
import { formatApiKeyType } from "components/ApiKeys/utils";
import FormFieldTimestamp from "components/FormFields/Timestamp";
import DescriptionDetails from "components/DescriptionDetails";
import { useShowFullDescriptionWithBackArrow } from "ds/components/FullDescriptionDrawer/useShowFullDescriptionWithBackArrow";

import { ApiKeyView } from "../../ApiKey/types";

type ApiKeysDetailsDrawerProps = {
  apiKey: ApiKeyView;
};

const ApiKeysDetailsDrawer = createDrawer(({ apiKey }: ApiKeysDetailsDrawerProps) => {
  const onOpenFullDescription = useShowFullDescriptionWithBackArrow(apiKey.description);

  return (
    <DrawerSimple isDismissable>
      <DrawerHeader justify="between">
        <DrawerHeaderTitle title="API key details" />
        <DrawerCloseIcon />
      </DrawerHeader>
      <DrawerBody fullHeight>
        <FormFieldViewText label="Name" value={apiKey.name} />
        <FormFieldViewText label="Key ID" value={apiKey.id} withCopy />
        <FormField label="Type">
          <Typography tag="span" variant="p-body2">
            {formatApiKeyType(apiKey.type)}
          </Typography>
        </FormField>
        {apiKey.type === ApiKeyType.Oidc && (
          <>
            <FormFieldViewText label="Issuer" value={apiKey.oidcSettings?.issuer} />
            <FormFieldViewText label="Client ID (audience)" value={apiKey.oidcSettings?.clientId} />
            <FormFieldViewText
              label="Subject expression"
              value={apiKey.oidcSettings?.subjectExpression}
            />
          </>
        )}
        {apiKey.creator && <FormFieldViewText label="Creator" value={apiKey.creator} />}
        {apiKey.lastUsedAt && (
          <FormFieldTimestamp label="Last used" timestamp={apiKey.lastUsedAt} />
        )}
        <DescriptionDetails
          description={apiKey.description}
          onOpenFullDescription={onOpenFullDescription}
        />
      </DrawerBody>
    </DrawerSimple>
  );
});

export const showApiKeysDetailsDrawer = createDrawerTrigger(ApiKeysDetailsDrawer);
